/* eslint-disable array-element-newline */
import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { useQuery } from "react-query";

import CourseCard from "../components/CourseCard";
import CourseSearchFilter from "../components/CourseSearchFilter";
import Loader from "../../../components/Loader";
import PaginationWithPage from "../../../components/PaginationWithPager";
import TabHeader from "../components/TabHeader";
import myCoursesQuery from "../services/myCoursesQuery";
import { useAuth } from "../../../services/wp.auth.service";

const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
const before = format(yesterday, "yyyy-MM-dd HH:mm:ss");

const MyAccountPastCourses = () => {

	const { user } = useAuth();
	const [currentCourses, setCurrentCourses] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [page, setPage] = useState(1);

	const {
		isLoading,
		data: myCourses
	} = myCoursesQuery(
		useQuery,
		{
			attendee: [String(user.attendeeId)],
			before,
			page,
			sort: "course_date_desc"
		},
		{
			enabled: !!user
		},
		"myPastCourses"
	);

	useEffect(() => {
		if (myCourses) {
			setCurrentCourses(myCourses.registrations);
		}
	}, [myCourses]);

	const handleSearch = useCallback(() => {
		const newSearchResults = currentCourses.filter((course) => {
			let match = false;

			/* eslint-disable curly */
			if (course.title.toLowerCase().includes(searchValue.toLowerCase())) match = true;
			if (course.description.toLowerCase().includes(searchValue.toLowerCase())) match = true;
			return match;
		});
		setCurrentCourses(newSearchResults);
	}, []);

	return (
		<>
			<TabHeader
				description="These are the past classes you registered for."
				title="Past Classes"
			/>

			{/* eslint-disable-next-line no-constant-condition */ }
			{false ? (
				<CourseSearchFilter
					handleSearch={handleSearch}
					searchValue={searchValue}
					setSearchValue={setSearchValue}
				/>) : null}

			{myCourses?.pager
				? (
					<div className="d-flex justify-content-between">
						<PaginationWithPage onChange={setPage} pager={myCourses.pager} />
						<div>Page {page} of {myCourses.pager.total_pages}</div>
					</div>) : null}

			{
				isLoading
					? <Loader height="200px" width="100%" />
					: currentCourses.map((registration) => <CourseCard course={registration.course} key={registration.id} />)
			}
		</>
	);

};

export default MyAccountPastCourses;
